import { UseFormReturnType } from "@mantine/form"
import { Loader, Select } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { CertificatesResponses } from "@tfg/types/endpoints/certificates"
import { CertificateUpdateDto } from "@tfg/types/schemas/modules/traceability/commands/update-certificate/update-certificate.request.dto"

import classes from "~/assets/css/Certificates.module.css"
import { useListCertificateTypesQuery } from "~/pages/SupplierPortal/ProductionSites/hooks/useListCertificteTypesQuery.ts"

type Props = {
  form: UseFormReturnType<CertificateUpdateDto>
}

export function CertificateTypeSelector({ form }: Props) {
  const { t } = useTranslation("certificates")
  const { data: certificateTypes, isLoading: certificatesLoading } =
    useListCertificateTypesQuery()

  if (certificatesLoading) {
    return <Loader />
  }
  return (
    <Select
      data={
        certificateTypes?.map((type: CertificatesResponses.CertificateType) => {
          return {
            ...type,
            value: type.id.toString(),
            label: type.name,
          }
        }) ?? []
      }
      label={t("modal.labels.type")}
      searchable
      placeholder={t("modal.placeholders.type")}
      classNames={classes}
      value={
        form.getInputProps("typeId").value
          ? form.getInputProps("typeId").value.toString()
          : null
      }
      onChange={(val) => {
        if (val) {
          form.setValues({ ...form.values, typeId: val })
        } else {
          form.setValues({ ...form.values, typeId: undefined })
        }
      }}
    />
  )
}
